module.exports = __webpack_public_path__ + "static/media/entActive.2f8060c6.svg";